var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompareArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88317 11.6667H2.0415V13.3334H7.88317V15.8334L11.2082 12.5001L7.88317 9.16675V11.6667ZM12.8665 10.8334V8.33341H18.7082V6.66675H12.8665V4.16675L9.5415 7.50008L12.8665 10.8334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareArrows);
export default __webpack_public_path__ + "static/media/compare_arrows.0b75e8b70fa3e2d9bcaf19806e9f8c15.svg";
export { ForwardRef as ReactComponent };